import { App } from 'vue'
import perm from './perm'

// 注册全局自定义组件
const useGlobalDirectives = (app: App): void => {
  app.directive(perm.directiveName, perm)
}

export {
  useGlobalDirectives
}
